module.exports = __webpack_public_path__ + "static/media/tutorial-3.d3eeb569.png";